import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isCreateScheduleInProgress: false,
  isSavingBasicDeatailsInProgress: false,
  isSavingSowingDeatailsInProgress: false,
  isActiveScheduleInProgress: false,
  isEditScheduleNameInProgress: false,
  saveAsDraftInProgress: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case '@@redux-form/RESET':
      if (
        action.meta.form === 'addScheduleName' ||
        action.meta.form === 'cropSchedule'
      ) {
        return initialState;
      } else {
        return state;
      }
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.CREATE_POP_SCHEDULE:
          return Object.assign({}, state, { isCreateScheduleInProgress: true });
        case actionTypes.SAVE_BASIC_DETAILS:
          return Object.assign({}, state, {
            isSavingBasicDeatailsInProgress: true,
          });
        case actionTypes.SAVE_SOWING_DETAILS:
          return Object.assign({}, state, {
            isSavingSowingDeatailsInProgress: true,
          });
        case actionTypes.SCHEDULE_STATUS:
          return Object.assign({}, state, { isActiveScheduleInProgress: true });
        case actionTypes.EDIT_SCHEDULE_NAME:
          return Object.assign({}, state, {
            isEditScheduleNameInProgress: true,
          });
        case actionTypes.SAVE_SCHEDULE_AS_DRAFT:
          return Object.assign({}, state, { saveAsDraftInProgress: true });
        case actionTypes.CHANGE_SCHEDULE_STATUS:
          return Object.assign({}, state, { isActiveScheduleInProgress: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.CREATE_POP_SCHEDULE:
          return Object.assign({}, state, {
            isCreateScheduleInProgress: false,
          });
        case actionTypes.SAVE_BASIC_DETAILS:
          return Object.assign({}, state, {
            isSavingBasicDeatailsInProgress: false,
          });
        case actionTypes.SAVE_SOWING_DETAILS:
          return Object.assign({}, state, {
            isSavingSowingDeatailsInProgress: false,
          });
        case actionTypes.SCHEDULE_STATUS:
          return Object.assign({}, state, {
            isActiveScheduleInProgress: false,
          });
        case actionTypes.EDIT_SCHEDULE_NAME:
          return Object.assign({}, state, {
            isEditScheduleNameInProgress: false,
          });
        case actionTypes.SAVE_SCHEDULE_AS_DRAFT:
          return Object.assign({}, state, { saveAsDraftInProgress: false });
        case actionTypes.CHANGE_SCHEDULE_STATUS:
          return Object.assign({}, state, {
            isActiveScheduleInProgress: false,
          });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
